import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { passwordAPI } from '../lib/api';
import { Mail, ArrowLeft, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await passwordAPI.forgotPassword(email);
      setSent(true);
      toast.success('If an account exists, a reset link has been sent.');
    } catch {
      toast.error('Something went wrong. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-xl border border-[#DADCE0] p-8">
          <div className="text-center mb-8">
            <div className="w-16 h-16 mx-auto bg-[#E8F0FE] rounded-full flex items-center justify-center mb-4">
              <Mail className="w-8 h-8 text-[#1A73E8]" />
            </div>
            <h1 className="text-2xl font-semibold text-[#202124]" style={{ fontFamily: 'Outfit' }}>
              {sent ? 'Check Your Email' : 'Forgot Password'}
            </h1>
            <p className="mt-2 text-[#5F6368]">
              {sent ? 'We sent a password reset link to your email address.' : 'Enter your email to receive a password reset link.'}
            </p>
          </div>

          {!sent ? (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-[#5F6368] mb-1">Email Address</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  className="input-google" required placeholder="your@email.com" data-testid="forgot-email" />
              </div>
              <button type="submit" disabled={loading} className="btn-google w-full flex items-center justify-center gap-2" data-testid="forgot-submit">
                {loading ? <RefreshCw className="w-5 h-5 animate-spin" /> : null}
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          ) : (
            <div className="text-center">
              <p className="text-sm text-[#5F6368] mb-4">
                Didn't receive the email? Check your spam folder and try again.
              </p>
              <button onClick={() => { setSent(false); setEmail(''); }} className="text-[#1A73E8] text-sm font-medium hover:underline">
                Try again
              </button>
            </div>
          )}

          <div className="mt-6 text-center">
            <Link to="/login" className="inline-flex items-center gap-1 text-sm text-[#1A73E8] hover:underline" data-testid="back-to-login">
              <ArrowLeft className="w-4 h-4" /> Back to Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
